<script >
import { h, ref } from 'vue'


export default {
    props: {
        activePage: Number
    },
    setup(props, context){

        return () => {
        let vnodes = context.slots.default();
        return h("div", {class: "switchDivs"}, vnodes.map((e,i) => {
                return h("div", {class: {"switchDiv": true, "active": i == props.activePage}}, e)
            }));
        }
    }
}

</script>

<style scoped>
    .switchDivs{
        display: grid;
        grid-template:
        "body" auto /
        auto;
        justify-items: center;
        align-items: center;
    }

    .switchDiv{
        grid-area: body;
        opacity: 0;
        pointer-events: none;
    }

    .active{
        opacity: 1;
        pointer-events: auto;
    }    

</style>